import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { BaseService } from './base.service';

@Injectable()
export class LogWizardService extends BaseService {
    constructor() {
        super();
        this._api = '/api/LogWizard/';        
    }

    postLogWizard(stepWizardId: number) {        
        var log = { StepWizardPortalCobrancaId: stepWizardId };
        this.post(`${this._api}`, log).subscribe(result => {            
        });              
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/services/logWizard.service.ts